import script from "./Paywall.vue?vue&type=script&setup=true&lang=js"
export * from "./Paywall.vue?vue&type=script&setup=true&lang=js"

import "./Paywall.vue?vue&type=style&index=0&id=1dc68e2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc68e2e"]])

export default __exports__